// extracted by mini-css-extract-plugin
export default {"top":"style_top__56h7m","word":"style_word__V4T7R","delete":"style_delete__CbSW+","flex":"style_flex__+inZY"};